import React, { useEffect } from "react";
import { contentHeader, TableText } from "../../Constancs/cssconst";
import { getList } from "../../functions/api";

const RecentActivity = ({ store, props }) => {
  useEffect(() => {
    getList({
      listUrl: "/logs/alllogs",
    }).then((res) => {
      console.log("alllogs", res);
      store.setvalue("Loglist", res?.data);
    });
  }, []);

  return (
    <>
      <h1 className={contentHeader}>Recent activity</h1>
      <div className="h-full overflow-x-auto flex items-center w-full flex-col gap-4">
        {store.getvalue("Loglist") &&
          store.getvalue("Loglist").map((item, index) => (
            <div
              key={index}
              className="bg-secondary rounded-2xl lg:py-1 lg:pl-3 lg:pr-1 xl:py-3 xl:pl-5 xl:pr-3  w-full flex items-center relative cursor-pointer hover:bg-[#a9a9ff] hover:bg-opacity-45"
              // onClick={() => {
              //   store.navTo("/demo/task/view/" + item.id);
              // }}
            >
              <h1 className={"text-primary font-light " + TableText}>
                {item.timeStamp.split("T")[0] +
                  " " +
                  item.timeStamp.split("T")[1].substring(0, 5) +
                  " - " +
                  item.operation_Type +
                  " - " +
                  item.userName +
                  " - " +
                  item.table_Name}
              </h1>
            </div>
          ))}
      </div>
    </>
  );
};

export default RecentActivity;
